import React from 'react'

import countries from '../../data/countries.json'

const SelectCountry = (props) => (
  <select className="input select" {...props} 
    onChange={props.onChange}>
    <option value="">Select Country</option>
    {
      countries.map(({code, name}, i) => 
        <option value={name} key={i}>{name}</option>
      )
    }
  </select>
)

export default SelectCountry


// WEBPACK FOOTER //
// ./src/components/micro/SelectCountry.js